import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=ada040a4&"
import script from "./order-status.vue?vue&type=script&lang=js&"
export * from "./order-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada040a4')) {
      api.createRecord('ada040a4', component.options)
    } else {
      api.reload('ada040a4', component.options)
    }
    module.hot.accept("./order-status.vue?vue&type=template&id=ada040a4&", function () {
      api.rerender('ada040a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/order-status/order-status.vue"
export default component.exports